import React, {FunctionComponent} from 'react';
import PageContentComponent from "../index";

type FooterSection = {
  data: {
    container: any;
  };
}

const FooterSection: FunctionComponent<FooterSection> = ({data}) => {

  return (
    <div className={"section"}>
      {data.container.map(boxes => {
        return (
          <div className={"box"} key={boxes._key}>
            <PageContentComponent
              key={boxes._key}
              content={boxes.footerBox}
            />
          </div>
        )
      })}
    </div>
  )
}

export default FooterSection;
